import { useEffect } from "react";
import { useLazyDownloadExportVisitsQuery } from "src/api/visitasApi";
import { ExportCompletedResponse, ExportFailedResponse, useSignalR } from "src/context/SignalRContext";
import { ToastContainer, toast } from "react-toastify";

export function DownloadsGlobalNotification() {
    const { onExportCompleted, onExportFailed } = useSignalR();
    const [downloadVisits] = useLazyDownloadExportVisitsQuery();

    useEffect(() => {

        const unsubComplete = onExportCompleted((data: ExportCompletedResponse) => {
            toast.success(
                <div>
                    <strong>El archivo esta listo</strong>
                    <br />
                    {/* <p */}
                    {/*     onClick={() => downloadVisits(data.jobId)} */}
                    {/*     className="underline font-semibold text-blue-600 hover:text-blue-800 cursor-pointer w-fit text-[13px]"> */}
                    {/*     Descargar manualmente */}
                    {/* </p> */}
                </div>,
                {
                position: 'bottom-right',
                autoClose: 10000,
                closeOnClick: false,
                draggable: true,
                }
            );

            // auto-download
            downloadVisits(data.jobId);
        });

        const unsubFailed = onExportFailed((data: ExportFailedResponse) => {
            toast.error(
                <div>
                    <strong>La exportación falló</strong>
                    <br />
                    {data.error}
                </div>,
                {
                    position: 'bottom-right',
                    autoClose: 7000,
                }
            );
        });

        return () => {
            unsubComplete();
            unsubFailed();
        };
    }, [onExportCompleted, onExportFailed]);

    return <ToastContainer position="bottom-right" newestOnTop />;
};
